function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 4,
  width: 22,
  height: 22,
  rx: 4,
  stroke: "white",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 6L9 2",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19 6L19 2",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1288 10.5456C13.5114 9.86693 14.4886 9.86693 14.8712 10.5456L15.6797 11.9801C15.8224 12.2333 16.0682 12.4118 16.3531 12.4693L17.9672 12.795C18.7308 12.9491 19.0328 13.8785 18.5056 14.452L17.3912 15.6643C17.1945 15.8782 17.1006 16.1672 17.134 16.4559L17.323 18.0917C17.4125 18.8655 16.6218 19.44 15.9135 19.1158L14.4162 18.4305C14.1519 18.3095 13.8481 18.3095 13.5838 18.4305L12.0865 19.1158C11.3782 19.44 10.5875 18.8655 10.677 18.0917L10.866 16.4559C10.8994 16.1672 10.8055 15.8782 10.6088 15.6643L9.49439 14.452C8.96716 13.8785 9.26916 12.9491 10.0328 12.795L11.6469 12.4693C11.9318 12.4118 12.1776 12.2333 12.3203 11.9801L13.1288 10.5456Z",
  fill: "#FFCB7C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1288 10.5456C13.5114 9.86693 14.4886 9.86693 14.8712 10.5456L15.6797 11.9801C15.8224 12.2333 16.0682 12.4118 16.3531 12.4693L17.9672 12.795C18.7308 12.9491 19.0328 13.8785 18.5056 14.452L17.3912 15.6643C17.1945 15.8782 17.1006 16.1672 17.134 16.4559L17.323 18.0917C17.4125 18.8655 16.6218 19.44 15.9135 19.1158L14.4162 18.4305C14.1519 18.3095 13.8481 18.3095 13.5838 18.4305L12.0865 19.1158C11.3782 19.44 10.5875 18.8655 10.677 18.0917L10.866 16.4559C10.8994 16.1672 10.8055 15.8782 10.6088 15.6643L9.49439 14.452C8.96716 13.8785 9.26916 12.9491 10.0328 12.795L11.6469 12.4693C11.9318 12.4118 12.1776 12.2333 12.3203 11.9801L13.1288 10.5456Z",
  stroke: "#DCD8E6"
});

var SvgColorCalendar = function SvgColorCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/color-calendar.76e502ed.svg";
export { ForwardRef as ReactComponent };